import React from "react";
import {STATUS_OPTIONS} from "../../../utils/constants";
import {OptionButton} from "../OptionButton";

interface StatusSelectorProps {
  selectedStatus: string;
  onChangeSelectedStatus: (status: string) => void;
}

export const StatusSelector = ({
  selectedStatus,
  onChangeSelectedStatus
}: StatusSelectorProps) => (
  <div className="flex gap-2 mt-0 mb-4 px-2 py-2 overflow-x-scroll">
    {STATUS_OPTIONS
      .map(status => (
        <OptionButton
          key={status.value}
          isSelected={selectedStatus === status.value}
          onClick={() => onChangeSelectedStatus(status.value)}
          label={status.label}
        />
      ))
    }
  </div>
)
